import type { FC } from 'react'
import {
  CuesGroupPlannedTimeRange,
  CuesGroupPlannedDuration,
  useGroupTiming,
  useGroupTimestamps,
} from '@/entities/cues-group'
import { CuesGroupTimingsWidget } from './cues-group-timings.widget.tsx'
import type { RundownCueOrderItem } from '@rundown-studio/types'

type CuesGroupPlannedTimingsProps = {
  childrenCues: RundownCueOrderItem[]
  timezone?: string | null
}

export const CuesGroupPlannedTimings: FC<CuesGroupPlannedTimingsProps> = ({
  childrenCues,
  timezone,
}) => {
  const groupTimestamps = useGroupTimestamps(childrenCues)
  const groupTiming = useGroupTiming(groupTimestamps)
  if (!groupTiming) return null

  return (
    <CuesGroupTimingsWidget
      Duration={<CuesGroupPlannedDuration groupTiming={groupTiming} />}
      Range={
        <CuesGroupPlannedTimeRange
          groupTiming={groupTiming}
          timezone={timezone}
        />
      }
    />
  )
}
